// Ticketing System Constants and Enums

// Ticket Categories Enum
export const TICKET_CATEGORIES = {
    GENERAL_ADMISSION: 'General Admission',
    VIP: 'VIP',
    RESERVED: 'Reserved',
    EARLY_BIRD: 'Early Bird',
    GROUP: 'Group',
    STUDENT: 'Student',
    SENIOR: 'Senior',
    MEMBERS_ONLY: 'Members Only',
    HIDDEN: 'Hidden',
    PAY_WHAT_YOU_CAN: 'Pay What You Can',
    TIER_1: 'Tier 1',
    TIER_2: 'Tier 2'
};

// Ticket Category Icons
export const TICKET_CATEGORY_ICONS = {
    [TICKET_CATEGORIES.GENERAL_ADMISSION]: '🎫',
    [TICKET_CATEGORIES.VIP]: '👑',
    [TICKET_CATEGORIES.RESERVED]: '💺',
    [TICKET_CATEGORIES.EARLY_BIRD]: '🐦',
    [TICKET_CATEGORIES.GROUP]: '👥',
    [TICKET_CATEGORIES.STUDENT]: '🎓',
    [TICKET_CATEGORIES.SENIOR]: '👴',
    [TICKET_CATEGORIES.MEMBERS_ONLY]: '🔒',
    [TICKET_CATEGORIES.HIDDEN]: '👁️',
    [TICKET_CATEGORIES.PAY_WHAT_YOU_CAN]: '💰',
    [TICKET_CATEGORIES.TIER_1]: '🥇',
    [TICKET_CATEGORIES.TIER_2]: '🥈'
};

// Ticket Category Labels
export const TICKET_CATEGORY_LABELS = {
    [TICKET_CATEGORIES.GENERAL_ADMISSION]: 'General Admission',
    [TICKET_CATEGORIES.VIP]: 'VIP Experience',
    [TICKET_CATEGORIES.RESERVED]: 'Reserved Seating',
    [TICKET_CATEGORIES.EARLY_BIRD]: 'Early Bird Special',
    [TICKET_CATEGORIES.GROUP]: 'Group Tickets',
    [TICKET_CATEGORIES.STUDENT]: 'Student Discount',
    [TICKET_CATEGORIES.SENIOR]: 'Senior Discount',
    [TICKET_CATEGORIES.MEMBERS_ONLY]: 'Members Only',
    [TICKET_CATEGORIES.HIDDEN]: 'Hidden Tickets',
    [TICKET_CATEGORIES.PAY_WHAT_YOU_CAN]: 'Pay What You Can',
    [TICKET_CATEGORIES.TIER_1]: 'Premium Tier',
    [TICKET_CATEGORIES.TIER_2]: 'Standard Tier'
};

// EventSection Types Enum
export const SECTION_TYPES = {
    STANDARD: 'STANDARD',
    PREMIUM: 'PREMIUM',
    VIP: 'VIP',
    BOX: 'BOX',
    FLOOR: 'FLOOR',
    BALCONY: 'BALCONY',
    MEZZANINE: 'MEZZANINE',
    ORCHESTRA: 'ORCHESTRA',
    ACCESSIBLE: 'ACCESSIBLE',
    STANDING: 'STANDING',
    GENERAL_ADMISSION: 'GENERAL_ADMISSION'
};

// Sample ticket categories (users can create custom ones)
export const SAMPLE_TICKET_CATEGORIES = [
    'General Admission',
    'VIP',
    'Reserved',
    'Early Bird',
    'Tier 1',
    'Tier 2',
    'Student',
    'Senior'
];

// Section Type Display Names
export const SECTION_TYPE_LABELS = {
    [SECTION_TYPES.STANDARD]: 'Standard',
    [SECTION_TYPES.PREMIUM]: 'Premium',
    [SECTION_TYPES.VIP]: 'VIP',
    [SECTION_TYPES.BOX]: 'Box Seats',
    [SECTION_TYPES.FLOOR]: 'Floor',
    [SECTION_TYPES.BALCONY]: 'Balcony',
    [SECTION_TYPES.MEZZANINE]: 'Mezzanine',
    [SECTION_TYPES.ORCHESTRA]: 'Orchestra',
    [SECTION_TYPES.ACCESSIBLE]: 'Accessible',
    [SECTION_TYPES.STANDING]: 'Standing Room',
    [SECTION_TYPES.GENERAL_ADMISSION]: 'General Admission'
};

// Section Type Colors (for visual representation)
export const SECTION_TYPE_COLORS = {
    [SECTION_TYPES.STANDARD]: '#45b7d1',
    [SECTION_TYPES.PREMIUM]: '#4ecdc4',
    [SECTION_TYPES.VIP]: '#9c27b0',
    [SECTION_TYPES.BOX]: '#ff6b6b',
    [SECTION_TYPES.FLOOR]: '#f39c12',
    [SECTION_TYPES.BALCONY]: '#96ceb4',
    [SECTION_TYPES.MEZZANINE]: '#dfe6e9',
    [SECTION_TYPES.ORCHESTRA]: '#6c5ce7',
    [SECTION_TYPES.ACCESSIBLE]: '#ff9800',
    [SECTION_TYPES.STANDING]: '#95a5a6',
    [SECTION_TYPES.GENERAL_ADMISSION]: '#34495e'
};

// Default ticket type configurations for new events
export const DEFAULT_TICKET_TYPES = {
    [TICKET_CATEGORIES.GENERAL_ADMISSION]: {
        category: TICKET_CATEGORIES.GENERAL_ADMISSION,
        code: 'GA',
        name: 'General Admission',
        description: 'Standard entry to the event',
        priceAmount: 50.00
    },
    [TICKET_CATEGORIES.VIP]: {
        category: TICKET_CATEGORIES.VIP,
        code: 'VIP',
        name: 'VIP Package',
        description: 'Premium experience with exclusive perks',
        priceAmount: 150.00
    },
    [TICKET_CATEGORIES.EARLY_BIRD]: {
        category: TICKET_CATEGORIES.EARLY_BIRD,
        code: 'EB',
        name: 'Early Bird',
        description: 'Special early booking discount',
        priceAmount: 40.00
    },
    [TICKET_CATEGORIES.GROUP]: {
        category: TICKET_CATEGORIES.GROUP,
        code: 'GRP',
        name: 'Group Tickets',
        description: 'Discounted tickets for groups',
        priceAmount: 45.00,
        minGroupSize: 5
    },
    [TICKET_CATEGORIES.STUDENT]: {
        category: TICKET_CATEGORIES.STUDENT,
        code: 'STU',
        name: 'Student Discount',
        description: 'Special pricing for students',
        priceAmount: 35.00
    },
    [TICKET_CATEGORIES.SENIOR]: {
        category: TICKET_CATEGORIES.SENIOR,
        code: 'SR',
        name: 'Senior Discount',
        description: 'Special pricing for seniors',
        priceAmount: 35.00
    },
    [TICKET_CATEGORIES.PAY_WHAT_YOU_CAN]: {
        category: TICKET_CATEGORIES.PAY_WHAT_YOU_CAN,
        code: 'PWYC',
        name: 'Pay What You Can',
        description: 'Flexible pricing option',
        priceAmount: 25.00,
        minPrice: 10.00
    }
}; 